import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section, StatusBadge, fmtTime } from "@/components/Shared";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function AdminAttendance() {
  const [recs, setRecs] = useState([]);
  const today = new Date().toISOString().slice(0, 10);
  const [from, setFrom] = useState(today);
  const [to, setTo] = useState(today);

  const load = async () => {
    try { const r = await api.get(`/attendance?from_date=${from}&to_date=${to}`); setRecs(r.data); }
    catch (e) { toast.error(formatErr(e)); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [from, to]);

  return (
    <div data-testid="admin-attendance">
      <PageHeader overline="Operations" title="Attendance"
        actions={<div className="flex gap-2"><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="rounded-none" /><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="rounded-none" /></div>} />
      <Section title={`${recs.length} records`}>
        <table className="w-full table-dense">
          <thead>
            <tr className="border-b-2 border-[#1F4E8C] text-left">
              <th className="eyebrow">Date</th><th className="eyebrow">Employee</th>
              <th className="eyebrow">In</th><th className="eyebrow">Out</th>
              <th className="eyebrow">Break</th><th className="eyebrow">Hours</th><th className="eyebrow">Status</th>
            </tr>
          </thead>
          <tbody>
            {recs.map((r) => (
              <tr key={r.id} className="border-b border-[#F0F0EE]">
                <td>{r.date}</td><td className="font-medium">{r.user_name}</td>
                <td>{fmtTime(r.clock_in)}</td><td>{fmtTime(r.clock_out)}</td>
                <td>{r.break_minutes || 0}m</td><td className="font-semibold">{r.working_hours}h</td>
                <td><StatusBadge status={r.status || "Present"} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>
    </div>
  );
}
